import React, { useState, useEffect } from 'react';
import "./DutyPage.css";
import { useAuth } from '../auth/Auth';

function UsersOnDutyPage() {
  const { user } = useAuth();
  const [dutyData, setDutyData] = useState([]);
  const [dutyStatuses, setDutyStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [theme, setTheme] = useState('white');
  
  const userId = user?.user_id || localStorage.getItem('userId') || '271';

  const userNamesMap = {
    '08a376410d57a49080f6437a6769e765': 'Пастушенко Карина',
    '6186dc0de930c4489f1cb0263fee3cb9': "Левицький Мар'ян",
    '96936d574385ce2328b697d75cc9ed25': 'Стецько Андрій',
    '7ae8cd52c6b536e7948e163d7eb79be1': 'Сенишин Максим.',
    '1c6c7ce92c2e99adb56f8a8743ef2c42': 'Грет Орест',
    '181919b1f3bb927d217d617c4938a885': 'Козак Дмитро',
    'e33d394cde1c7788e4371a5df8c91e7f': 'Герій Олег',
    '888c3b61bb6fc84e462cace3802f5a80': 'Островська Катерина',
    '68cbc91a9357786b674d12f48dbeec5e': 'Павлюк Микола',
    '32478442b5013f8cef0c0a8b07f72dce': 'Коневич Роман',
    'ed863fbec1ec7d6360f62d54942f0655': 'Здеорук Вікторія',
    '8c0d7c9a8853178be96fa60ed8b0298b': 'Чічкін Ігор',
    '7115979f5af389e660bf57e21e10e73a': 'Рихлінський Руслан',
    '9e91681968c552d39c3943cd489de8dd': 'Віролюбова Анастасія',
    '1e9b56558fc6ef081b646ebce9c6d2b7': 'Николайчук Дарья',
    'e90cbdecf165c5b7501e6b52315e0481': 'Єсипович Євген',
    'ecb7033508c49fefc6f146fed1cdbde6': 'Левицький Микита',
    '70d9217877877f35c58a57729a36455e': 'Здеорук Олександра',
    '6b00290e92ccab45f933e1118fbc36f8': 'Петрів Юрій',
    '253db11e2987d6eebe524da08ca3c33a': 'Петрів Степан',
    '19149f434b36af055a1a14ee7dea719d': 'Рось Іван',
    '84053c23a95a2f20256e351a6464f38e': 'Бишко Данило',
    '70bab5c0b422829d5f51dd0c1a6a925e': 'Сальников Валентин',
    'ed2024a4e80d57e488ae8c16d6bc52eb': 'Зеленіков Дмитро',
    '76': 'Сачовська Діана',
    '045205e9750e89e7aa8a88eea1e90ba1': 'Сачовська Діана',
    '77': 'Дудар Максим',
    '528295c587f8204164b129b01c68f1f9': 'Дудар Максим',
    '4514b8da7b9d9ae0f612eb3a9316c2ee': 'Мелих Владислав',
    '78': 'Мелих Владислав',
    '5a2471cc0559c9bed479ebeaa2810456': 'Ванденко Максим',
    'Chat Manager Syrve POS Support': 'Chat Manager Syrve POS Support',
    '43481fb68ba4c410a7413a331ae63e2d': 'Шершньов Микита',
    'd9bc61c8d39e7373c61e61a04073b9a8': 'Гіщинський Любомир',
    '4fee0b2cd341f9ca21a174006703164d': 'Лебідь Роман',
      'bfd39278cf8337ccbf4eb10878d229da': 'Даниленко Денис',
       '74fa21afdcce740f82d72c5f3b6b5d55': 'Шульська Аліна',
        'dc58ddc1c7a369bcf15936d93ed911d3': 'Роман Ірина',
       'b843e12a0cb74f150b46ce4869da2ba4': 'Клепацький Дмитро',
      '21a3c2811d3a9d5e80ae58ed2dee08af': 'Когут Марія',
       'a4512bf2acb5c96a3254c819f0a358d4': 'Морозюк Роман',
        '3b17ccb07571b6c02427fa6ebe584dc7': 'Мазурян Евеліна',
       'a707c5bab2d536a1df71095e588534b7': 'Нестерович Євгеній',
       '25009328c12e7616e397462b3ac403a7': 'Колбінов Валентин',
        '7ba3395596ec209f829d5f4b846d6cd7': 'Керніцька Христина',
     '725301d7478b0bf2e0db9c1c8c2c1234': 'Запольська Єлизавета',
       '2fc4fe00de48cd6b723a21cd17e562fc': 'Смирнова Кристина',
  };


  const fetchThemeConfig = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/user-theme-config/${userId}`);
      if (response.ok) {
        const config = await response.json();
        setTheme(config.theme || 'white');
        console.log('Theme loaded:', config.theme);
      } else {
        console.error('Failed to fetch theme config:', response.status);
        setTheme('white');
      }
    } catch (error) {
      console.error('Error fetching theme config:', error);
      setTheme('white');
    }
  };

 
  const getUsersByRole = (roleKey) => {
    const usersOnDuty = [];
    
    Object.keys(dutyStatuses).forEach(userId => {
      const status = dutyStatuses[userId];
      const userName = userNamesMap[userId] || `${userId}`;
      
      let isActive = false;
      
      switch(roleKey) {
        case 'coordinator':
          isActive = status.coordinator === 'yes';
          break;
        case 'mentor':
          isActive = status.mentor === 'yes';
          break;
        case 'duty_task':
          isActive = status.duty_task === 'yes';
          break;
        case 'duty_chat':
          isActive = status.duty_chat === 'yes';
          break;
        case 'teamlead':
          isActive = status.teamlead === 'yes';
          break;
      }
      
      if (isActive) {
        usersOnDuty.push({
          id: userId,
          name: userName,
          status: status
        });
      }
    });
    
    return usersOnDuty;
  };

  useEffect(() => {
    if (user?.user_id) {
      localStorage.setItem('userId', user.user_id);
    }
  }, [user?.user_id]);

  useEffect(() => {
    fetchThemeConfig();
  }, [userId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError('');
        setLoading(true);
        
        const [dutyStatusesResponse] = await Promise.all([
          fetch(`https://hub2.daolog.net/api/duty-statuses`)
        ]);
        
        const dutyStatusesData = await dutyStatusesResponse.json();

        if (dutyStatusesData.success) {
          console.log('Fetched duty statuses:', dutyStatusesData.dutyStatuses);
          setDutyStatuses(dutyStatusesData.dutyStatuses || {});
        } else {
          console.error('Failed to fetch duty statuses');
          setDutyStatuses({});
        }
        
      } catch (error) {
        console.error('Помилка завантаження даних:', error);
        setError(`Помилка завантаження даних: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, [userId]);

  const roleConfig = [
    {
      key: 'coordinator',
      title: 'Координатор',
      icon: '⭐',

    },
    {
      key: 'mentor',
      title: 'Ментор',
      icon: '🎓',
    },
    {
      key: 'duty_task',
      title: 'Чергові (задачі)',
      icon: '📋',
    },
    {
      key: 'duty_chat',
      title: 'Чергові (чати)',
      icon: '💬',
    },
    {
      key: 'teamlead',
      title: 'Тімлід',
      icon: '👨‍💼',
    }
  ];

  const UserCard = ({ user }) => {
    return (
      <div className="user-card" key={user.id}>
        <div className="user-card-content">
          <div className="user-main-info">
            <div className="user-name">{user.name}</div>
            <div className="user-roles-inline">
              {user.status.coordinator === 'yes' && <span className="role-badge-small coordinator">⭐</span>}
              {user.status.mentor === 'yes' && <span className="role-badge-small mentor">🎓</span>}
              {user.status.duty_task === 'yes' && <span className="role-badge-small duty-task">📋</span>}
              {user.status.duty_chat === 'yes' && <span className="role-badge-small duty-chat">💬</span>}
              {user.status.teamlead === 'yes' && <span className="role-badge-small teamlead">👨‍💼</span>}
            </div>
          </div>
          <div className="user-roles-full">
            {user.status.coordinator === 'yes' && <span className="role-badge coordinator">⭐ Координатор</span>}
            {user.status.mentor === 'yes' && <span className="role-badge mentor">🎓 Ментор</span>}
            {user.status.duty_task === 'yes' && <span className="role-badge duty-task">📋 Задачі</span>}
            {user.status.duty_chat === 'yes' && <span className="role-badge duty-chat">💬 Чати</span>}
            {user.status.teamlead === 'yes' && <span className="role-badge teamlead">👨‍💼 Тімлід</span>}
          </div>
        </div>
      </div>
    );
  };
  const RoleColumn = ({ role }) => {
    const users = getUsersByRole(role.key);
    
    return (
      <div className="role-column">
        <div className="role-header">
          <div className="role-title">
            <span className="role-icon">{role.icon}</span>
            <h3>{role.title}</h3>
          </div>
          <div className="role-description">{role.description}</div>
          <div className="user-count">
            {users.length} {users.length === 1 ? 'користувач' : 
                           users.length > 1 && users.length < 5 ? 'користувачі' : 
                           'користувачів'}
          </div>
        </div>
        
        <div className="users-list">
          {users.length > 0 ? (
            users.map(user => (
              <UserCard key={user.id} user={user} />
            ))
          ) : (
            <div className="no-users-message">
              Немає користувачів на цій ролі
            </div>
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return <div className={`users-on-duty-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}><div className="loading">Завантаження...</div></div>;
  }

  if (error) {
    return <div className={`users-on-duty-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}><div className="error">{error}</div></div>;
  }

  return (
    <div className={`users-on-duty-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}>
      <div className="page-header">
        <h1>Хто на зміні</h1>
       
      </div>
      
      <div className="summary-stats">
    
      
       
       
      </div>
      
      <div className="roles-grid">
        {roleConfig.map(role => (
          <RoleColumn key={role.key} role={role} />
        ))}
      </div>
      
      
    </div>
  );
}

export default UsersOnDutyPage;